import React from 'react';
import './styles.css';
import {
	ADMIN,
	ECE,
	TEACHER,
	STUDENT,
	PARENT
} from '@BUP/constants';
import { Row, Col, Button } from 'antd';
import { useHistory } from 'react-router-dom';

const SendMessageText = ({ role }) => {
	const history = useHistory();

	if (role === ECE || role === ADMIN) {
		return (
			<div className="send-message-text-wrapper">
				<div className="bold-text">
					<h2>
						¿QUÉ ES EL MODO BUP!?
					</h2>
				</div>
				<div className="normal-text">
					<p>
						Es un canal de comunicación directo con el equipo de convivencia escolar, donde de forma anónima o no,
						profesores, estudiantes y/o apoderados pueden escribir, sobre distintas situaciones de convivencia que suceden entre los miembros
						de la comunidad escolar, ya sea en el espacio físico o digital. De esta manera se potenciará una comunidad donde todos(as) sean responsables de construir
						una sana convivencia escolar. <br /><br />
						Aquí encontrarás la <span className="word-bold">Bandeja de Entrada</span> donde recibirás los mensajes enviados por tu comunidad y la seccion
						de <span className="word-bold">Casos Archivados</span> donde podrás guardar los casos que ya fueron resueltos. Te invitamos a que revises ambas secciones:
					</p>
				</div>
				<Row style={{ width: '100%' }}>
					<Col span={24} style={{ display: 'flex', justifyContent: 'space-evenly' }}>
						<Button
							size="large"
							type="primary"
							onClick={() => history.push('/modebup/inbox')}
						>
							Bandeja de Entrada
				 		</Button>
						<Button
							size="large"
							type="primary"
							onClick={() => history.push('/modebup/archived')}
						>
							Casos Archivados
				 		</Button>
					</Col>
					<Col span={24} style={{ marginTop: 40 }}>
						<div className="normal-text">
							<p>
								<span className="word-bold">
									Recuerda que en este espacio podrás conocer y atender en tiempo real las problemáticas y necesidades de tu comunidad.
								</span>
							</p>
							<p>
								Conocer las experiencias y situaciones desafiantes a las que se enfrentan, posibilita intervenir de manera preventiva, además de dar apoyo y contención.
							</p>
						</div>
					</Col>
				</Row>
			</div>
		)
	}
	if (role === PARENT) {
		return (
			<div className="send-message-text-wrapper">
				<div className="normal-text">
					<p>
						En este espacio podrás expresar y comunicar situaciones de conflictos, agresiones o malentendidos entre miembros de la comunidad, así también para encontrar apoyo en problemáticas que puedan estar viviendo sus hijos/as.
					</p>
				</div>
			</div>
		)
	}
	if (role === TEACHER) {
		return (
			<div className="send-message-text-wrapper">
				<div className="bold-text">
					<h2>
						En este espacio podrás dar a conocer situaciones particulares o grupales de convivencia escolar.
					</h2>
				</div>
				<div className="normal-text">
					<p>
						De modo que el equipo de convivencia cuente con información y antecedentes, así como informar necesidades y comunicar preocupaciones relativas al bienestar de los(as) estudiantes. Encontrar apoyo para intervenir efectivamente con sus estudiantes.
					</p>
				</div>
			</div>
		)
	}
	if (role === STUDENT) {
		return (
			<div className="send-message-text-wrapper">
				<div className="bold-text">
					<h2>
						En este espacio podrás encontrar desahogo, contención y apoyo para poder enfrentar de forma positiva la situación expuesta.
					</h2>
				</div>
				<div className="normal-text">
					<p>
						Podrás comunicar situaciones y/o experiencias personales o de otros, de acoso escolar, ciberacoso u otras situaciones que te afecten y no sepas cómo solucionar. También puedes utilizar este espacio para hacer propuestas para mejorar la convivencia dentro de tu comunidad.
					</p>
				</div>
			</div>
		)
	}
	return null
};

SendMessageText.defaultProps = {
	role: "STUDENT"
}

export default SendMessageText;